import { Component, effect, output, ChangeDetectionStrategy } from '@angular/core';
import { Validators } from '@angular/forms';
import { SafeStyle } from '@angular/platform-browser';
import { StyleHelper } from '@xanadu/common';
import { InputComponent } from '../input/input.component';

@Component({
    selector: 'app-textarea',
    templateUrl: './textarea.component.html',
    styleUrls: ['./textarea.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TextareaComponent extends InputComponent {
    public change = output<string>();

    public textStyle?: SafeStyle;

    constructor(
        private readonly styleHelper: StyleHelper
    ) {
        super();

        effect(() => {
            const meta = this.meta();

            if (meta?.textStyle) {
                this.textStyle = this.styleHelper.parse(meta.textStyle);
            }
        });
    }

    onChange(event: any) {
        this.change.emit(event);
    }

    protected getValidators(): any[] {
        const validators = super.getValidators();
        const meta = this.meta();
        if (meta) {
            if (meta.pattern) {
                validators.push(Validators.pattern(meta.pattern));
            }
        }
        return validators;
    }
}
